import React, { useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Grid,
  InputAdornment,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import { useStyles } from "../../../theme/appStyles";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import {
  useGetCategoryQuery,
  useGetPrinterQuery,
  useGetTaxQuery,
  useDeleteCategoryMutation,
  useGetBrandQuery,
  useGetProducHistroyRecordQuery,
  useGetProducStoreHistroyRecordQuery,
  useGetTagQuery,
  useGetStoreQuery,
  useGetMainItemQuery,
  useGetUserInfoOnyQuery,
  useGetProducOrderListRecodQuery,
  useGetAllAdminOrderListQuery,
  useGetAllMainCategoryQuery,
  useGetProductQuery,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IMainItem,
  IVariantView,
  IStore,
  IBrand,
  ITag,
  IPrinter,
  IProductPriceSplineChart,
  IUserAdmin,
  IOrderItemViewList2,
  IOrderList,
  ITaxes,
} from "../../../Api/Interface/api.interface";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import NewPopUpProduct from "../Edit/index";
import { useNotifier } from "../../../Core/Notifier";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import {
  ItemServiceChargeType,
  RooleType,
  SizeOfLevelType,
} from "../../../Core/Enum/enum";
import StoreIcon from "@mui/icons-material/Store";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import dayjs, { Dayjs } from "dayjs";
import { IoIosImages } from "react-icons/io";
import useIsMobile from "../../../Core/hook/useIsMobile";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ReorderIcon from "@mui/icons-material/Reorder";
import Pagination from "../../../Components/Pagination";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import ReplaceImage from "../../../Images/repImg.png";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const convertUnit = (unit: number) => {
  switch (unit) {
    case SizeOfLevelType.kg:
      return "kg";
    case SizeOfLevelType.small:
      return "small";
    case SizeOfLevelType.li:
      return "li";
    case SizeOfLevelType.Medium:
      return "Medium";
    case SizeOfLevelType.Bottle:
      return "Bottle";
    case SizeOfLevelType.Each:
      return "Each";
    case SizeOfLevelType.Large:
      return "Large";
    case SizeOfLevelType.case:
      return "Case";
    case SizeOfLevelType.lb:
      return "lb";
    default:
      return "";
  }
};

const getSizeLabel = (value: number) => {
  const entry = Object.entries(SizeOfLevelType).find(
    ([_, val]) => val === value
  );
  return entry ? entry[0] : "";
};

const getRooleTypeLabel = (value: number) => {
  const entry = Object.entries(RooleType).find(([_, val]) => val === value);
  return entry ? entry[0] : "";
};

const getItemServiceSizeLabel = (value: string | number) => {
  const numericValue = Number(value);

  const entry = Object.entries(ItemServiceChargeType).find(
    ([_, val]) => val === numericValue
  );

  return entry ? entry[0] : "";
};

const capitalizeFirstLetter = (name: string) =>
  name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

enum Section {
  Store = "Store",
  Product = "Product",
  Items = "Items",
}

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { showErrorMessage, showMessage } = useNotifier();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const isMobileRes = useIsMobile();
  const [activeSection, setActiveSection] = useState<Section>(Section.Store);
  const handleContainerChange = (section: Section) => {
    setActiveSection(section);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<ICategory | null>(
    null
  );
  const [openDialogProduct, setOpenDialogProduct] = useState(false);
  const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
  const [productToDelete, setProductToDelete] = useState<ICategory | null>(
    null
  );
  const [selectCustomer, setSelectCustomer] = useState<IMainItem | null>(null);
  const [selectedProduct2, setSelectedProduct2] = useState<ICategory | null>(
    null
  );
  const [openDialogProduct2, setOpenDialogProduct2] = useState(false);
  const { id: ProductId } = useParams<{ id: string }>();

  useEffect(() => {}, [ProductId]);

  const { data, isLoading, isError } = useGetAllMainCategoryQuery({
    departmentId: "",
    coursingId: "",
    roleId: null,
    taxeId: "",
    createdDateStart: null,
    createdDateEnd: null,
    searchText: "",
    numberOfLength: 0,
    isActive: true,
    categoryIsLooping: null,
    createdDate: null,
    id: String(ProductId),
  });

  const { data: storeData, isLoading: storeIsLoading } = useGetStoreQuery({
    searchText: "",
    id: "",
  });

  const { data: productBrandData, isLoading: brandIsLoading } =
    useGetBrandQuery({
      searchText: "",
      isActive: "1",
      id: "",
    });
  const { data: productTagData, isLoading: ProductTagLoading } = useGetTagQuery(
    {
      searchText: "",
      isActive: "1",
      id: "",
    }
  );

  const { data: printerData, isLoading: PrinterLoading } = useGetPrinterQuery({
    searchText: "",
  });

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery();

  const { data: taxData, isLoading: taxLoading } = useGetTaxQuery({
    searchText: "",
  });

  const {
    data: productStoreHistoryRecordData,
    isLoading: storeRecordIsLoading,
  } = useGetProducStoreHistroyRecordQuery({
    productDetailsId: String(ProductId),
  });

  const {
    data: productHistoryRecordData,
    isLoading: productRecordIsLoading,
    isError: productIsError,
  } = useGetProducHistroyRecordQuery({
    productDetailsId: String(ProductId),
  });

  const {
    data: variantData,
    isLoading: variantIsLoading,
    isError: variantIsError,
  } = useGetProductQuery({
    searchText: "",
    id: "",
    variantBrandId: null,
    categoryId: String(ProductId),
    variantTagId: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
    mainItemId: null,
  });

  const {
    data: mainItemData,
    isLoading: mainItemGetIsLoading,
    isError: mainItemIsError,
  } = useGetMainItemQuery({
    searchText: "",
    id: "",
    variantBrandId: null,
    categoryId: String(ProductId),
    variantTagId: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });

  const { data: maintItemData, isLoading: mainItemIsLoading } =
    useGetMainItemQuery({
      searchText: "",
      id: "",
      variantBrandId: null,
      categoryId: null,
      variantTagId: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      createdDate: null,
    });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const {
    data: SentToManagerData,
    isLoading: SentToManagerIsLoading,
    isError: SentToManagerIsError,
  } = useGetAllAdminOrderListQuery({
    searchText: "",
    orderListStatus: "",
    id: "",
  });

  const product = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as ICategory;
    }
    return null;
  }, [data]);

  const getAllStoreList = useMemo(() => {
    return storeData?.data as IStore[];
  }, [storeData?.data]);

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const productBrandList = useMemo(() => {
    return productBrandData?.data as IBrand[];
  }, [productBrandData?.data]);

  const productTagList = useMemo(() => {
    return productTagData?.data as ITag[];
  }, [productTagData?.data]);

  const printerList = useMemo(() => {
    return printerData?.data as IPrinter[];
  }, [printerData?.data]);

  const orderList = useMemo(() => {
    return SentToManagerData?.data as IOrderList[];
  }, [SentToManagerData?.data]);

  const productHistoryRecordList = useMemo(() => {
    return productStoreHistoryRecordData?.data as IProductPriceSplineChart[];
  }, [productStoreHistoryRecordData?.data]);

  const mainItemList = useMemo(() => {
    return maintItemData?.data as IMainItem[];
  }, [maintItemData?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const taxList = useMemo(() => {
    return taxData?.data as ITaxes[];
  }, [taxData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  const orderListMap = useMemo(() => {
    const map = new Map();
    orderList?.forEach((category) => {
      map.set(category.id, `${category.orderListId}`);
    });
    return map;
  }, [orderList]);

  const categoryMap = useMemo(() => {
    const map = new Map();
    categoryList?.forEach((category) => {
      map.set(category.id, toProperCase(category.categoryName));
    });
    return map;
  }, [categoryList]);

  const taxMap = useMemo(() => {
    const map = new Map();
    taxList?.forEach((category) => {
      map.set(category.id, toProperCase(category.taxName));
    });
    return map;
  }, [taxList]);

  const mainItenMap = useMemo(() => {
    const map = new Map();
    mainItemList?.forEach((category) => {
      map.set(category.id, toProperCase(category.mainItemName));
    });
    return map;
  }, [mainItemList]);

  const productBrandMap = useMemo(() => {
    const map = new Map();
    productBrandList?.forEach((brand) => {
      map.set(brand.id, toProperCase(brand.brandName));
    });
    return map;
  }, [productBrandList]);

  const tagMap = useMemo(() => {
    const map = new Map();
    productTagList?.forEach((brand) => {
      map.set(brand.id, brand.tagName);
    });
    return map;
  }, [productTagList]);

  const printerMap = useMemo(() => {
    const map = new Map();
    printerList?.forEach((brand) => {
      map.set(brand.id, toProperCase(brand.printerName));
    });
    return map;
  }, [printerList]);

  const getStoreMap = useMemo(() => {
    const map = new Map();
    getAllStoreList?.forEach((category) => {
      map.set(category.id, toProperCase(category.storeName));
    });
    return map;
  }, [getAllStoreList]);

  const handleOpenDialog = (product: ICategory) => {
    setSelectedProduct(product);
    setOpenDialogProduct(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialogProduct(false);
  };

  const handleOpenDialog2 = (product: ICategory) => {
    setSelectedProduct2(product);
    setOpenDialogProduct2(true);
  };

  const handleCloseDialog2 = () => {
    setSelectedProduct2(null);
    setOpenDialogProduct2(false);
  };

  const handleOpenDeletePopup = (product: ICategory) => {
    setProductToDelete(product);
    setOpenDeleteProduct(true);
  };

  const handleCloseDeletePopup = () => {
    setProductToDelete(null);
    setOpenDeleteProduct(false);
  };

  const handleAddProductClick = () => {
    navigate(`/product/create/${product?.id}`);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const [deleteCategory] = useDeleteCategoryMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteProduct(false);
        navigate(`/category/list`);
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the product");
    }
  };

  const StatusCard = ({ label, value }: { label: string; value: boolean }) => (
    <Card
      sx={{
        padding: 2,
        height: "100%",
        border: `1px solid ${value ? "#4caf50" : "#f44336"}`,
        backgroundColor: value ? "#e8f5e9" : "#ffebee",
        borderRadius: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      }}
    >
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        wrap="nowrap"
      >
        <Typography variant="subtitle1" fontWeight={600}>
          {label}
        </Typography>
        {value ? (
          <CheckCircleOutlinedIcon sx={{ color: "#4caf50", fontSize: 36 }} />
        ) : (
          <HighlightOffOutlinedIcon sx={{ color: "#f44336", fontSize: 36 }} />
        )}
      </Grid>
    </Card>
  );

  const CompactStatusCard = ({
    label,
    status,
  }: {
    label: string;
    status: boolean;
  }) => {
    const iconColor = status ? "#4caf50" : "#f44336";
    const iconBg = status ? "#e8f5e9" : "#ffebee";
    const Icon = status ? CheckCircleIcon : CancelIcon;

    return (
      <Card className={classes.variantviewfristcard}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar sx={{ bgcolor: iconBg, color: iconColor }}>
            <Icon />
          </Avatar>
          <Typography variant="subtitle1" fontWeight={500}>
            {label}
          </Typography>
        </Stack>
      </Card>
    );
  };

  interface SelectCardProps {
    label: string;
    selecte: boolean;
    icon: React.ReactNode;
  }

  const SelectCard: React.FC<SelectCardProps> = ({ label, selecte, icon }) => {
    return (
      <Card
        className={
          selecte ? classes.selectedcardVariant : classes.unselectedcardVariant
        }
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar>{icon}</Avatar>
          <Typography variant="subtitle1" fontWeight={500}>
            {label}
          </Typography>
        </Stack>
      </Card>
    );
  };

  type DetailRowProps = {
    label: string;
    value: React.ReactNode;
  };
  const DetailRow: React.FC<DetailRowProps> = ({ label, value }) => (
    <Typography
      variant="subtitle1"
      sx={{
        display: "flex",
        borderBottom: "1px solid #e0e0e0",
        py: 0.8,
      }}
    >
      <Box
        component="span"
        sx={{
          width: "30%",
          fontWeight: 600,
          pr: 1,
        }}
      >
        {label}
      </Box>
      <Box
        component="span"
        sx={{
          width: "5%",
          fontWeight: 600,
          pr: 1,
        }}
      >
        {` : `}
      </Box>
      <Box
        component="span"
        sx={{
          width: "65%",
          pr: 1,
        }}
      >
        {value}
      </Box>
    </Typography>
  );

  const storeItemsList: IVariantView[] = Array.isArray(variantData?.data)
    ? (variantData?.data as IVariantView[])
    : [];

  const mainItemlist: IMainItem[] = Array.isArray(mainItemData?.data)
    ? (mainItemData?.data as IMainItem[])
    : [];

  if (
    isLoading ||
    categoryLoading ||
    storeIsLoading ||
    brandIsLoading ||
    ProductTagLoading ||
    PrinterLoading ||
    productRecordIsLoading ||
    mainItemIsLoading ||
    userIsLoading ||
    SentToManagerIsLoading ||
    mainItemGetIsLoading ||
    variantIsLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const renderContent = () => {
    switch (activeSection) {
      case Section.Items:
        return (
          <div>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container justifyContent={"space-between"} spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      height: "90vh",
                      overflow: "auto",
                      padding: "2px",
                      "&::-webkit-scrollbar": {
                        width: "4px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#eeeeee",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#eeeeee",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#eeeeee",
                      },
                    }}
                  >
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={2}
                      // sx={{ px: 2, pb: 3 }}
                      className={classes.titleGrid}
                    >
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Card className={classes.stepperCard}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={1}
                            sx={{
                              // borderBottom: 2,
                              padding: 2,
                            }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                alignContent: "center",
                              }}
                            >
                              <Typography
                                gutterBottom
                                className={classes.variantViewHedingeProg}
                              >
                                Variants History
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid>
                            <TableContainer>
                              <Table className={classes.table}>
                                <TableHead className={classes.tableHeaderRow}>
                                  <TableRow>
                                    <TableCell
                                      className={classes.tablheaderNoWidth}
                                      sx={{ width: "5%" }}
                                    >
                                      <strong>#</strong>
                                    </TableCell>
                                    <TableCell
                                      className={classes.tablheader}
                                      sx={{ width: "60%" }}
                                    >
                                      <strong>Name</strong>
                                    </TableCell>

                                    <TableCell
                                      className={classes.tablheader}
                                      sx={{ textAlign: "right" }}
                                    >
                                      <strong>Actions</strong>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {variantIsError ||
                                  storeItemsList.length === 0 ? (
                                    <TableRow>
                                      <TableCell colSpan={20} align="center">
                                        {variantIsError
                                          ? "Error fetching data"
                                          : "No data available"}
                                      </TableCell>
                                    </TableRow>
                                  ) : (
                                    storeItemsList
                                      .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                      )
                                      .map((row: IVariantView, index) => (
                                        <TableRow
                                          key={row.id}
                                          className={classes.tableRowHover}
                                        >
                                          <TableCell
                                            scope="row"
                                            className={classes.tablCell}
                                            // sx={{ textAlign: "center" }}
                                          >
                                            {index + 1}
                                          </TableCell>

                                          <TableCell
                                            scope="row"
                                            className={classes.tablCell}
                                          >
                                            <Link
                                              to={`/variant/view/${row.id}`}
                                              className={
                                                classes.iconLinkPropNormal
                                              }
                                            >
                                              <Grid
                                                container
                                                spacing={1}
                                                alignItems="center"
                                                sx={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  navigate(
                                                    `/variant/view/${row.id}`
                                                  )
                                                }
                                              >
                                                <Grid item xs="auto">
                                                  <Box
                                                    className={
                                                      classes.SelectImageTableBoxwithBorder
                                                    }
                                                  >
                                                    {row.variantImg ||
                                                    ReplaceImage ? (
                                                      <img
                                                        src={
                                                          row.variantImg ||
                                                          ReplaceImage
                                                        }
                                                        alt="img"
                                                        className={
                                                          classes.SelectImageTable
                                                        }
                                                        onError={(e) =>
                                                          (e.currentTarget.src =
                                                            ReplaceImage)
                                                        }
                                                      />
                                                    ) : (
                                                      <IoIosImages
                                                        className={
                                                          classes.SelectImageTable
                                                        }
                                                      />
                                                    )}
                                                  </Box>
                                                </Grid>
                                                <Grid item xs>
                                                  <Typography
                                                    className={
                                                      classes.nameTableList
                                                    }
                                                  >
                                                    {toProperCase(
                                                      row.variantName
                                                    )}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Link>
                                          </TableCell>

                                          <TableCell
                                            className={classes.tablCell}
                                          >
                                            <Grid
                                              container
                                              spacing={1}
                                              sx={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                              }}
                                            >
                                              <Grid item>
                                                <Link
                                                  to={`/variant/view/${row.id}`}
                                                  className={
                                                    classes.iconLinkPropNormal
                                                  }
                                                >
                                                  <Button
                                                    className={
                                                      classes.viewButtonList
                                                    }
                                                  >
                                                    <VisibilitySharpIcon
                                                      className={
                                                        classes.viewListIcon
                                                      }
                                                    />
                                                  </Button>
                                                </Link>
                                              </Grid>
                                            </Grid>
                                          </TableCell>
                                        </TableRow>
                                      ))
                                  )}
                                </TableBody>
                              </Table>

                              <Grid
                                spacing={5}
                                p={"18px"}
                                py={4}
                                justifyContent={"end"}
                                container
                                textAlign={"center"}
                                alignContent={"center"}
                                alignItems={"center"}
                              >
                                <Grid
                                  sx={{
                                    textAlign: "end",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end",
                                  }}
                                >
                                  <Pagination
                                    count={storeItemsList.length}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    onPageChange={handleChangePage}
                                  />
                                </Grid>
                              </Grid>
                            </TableContainer>
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </div>
        );
      case Section.Product:
        return (
          <div>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container justifyContent={"space-between"} spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      height: "90vh",
                      overflow: "auto",
                      padding: "2px",
                      "&::-webkit-scrollbar": {
                        width: "4px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#eeeeee",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#eeeeee",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#eeeeee",
                      },
                    }}
                  >
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={2}
                      // sx={{ px: 2, pb: 3 }}
                      className={classes.titleGrid}
                    >
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Card className={classes.stepperCard}>
                          <Grid
                            container
                            justifyContent={"space-between"}
                            spacing={1}
                            sx={{
                              // borderBottom: 2,
                              padding: 2,
                            }}
                            className={classes.titleGrid}
                          >
                            <Grid
                              item
                              sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                                alignContent: "center",
                              }}
                            >
                              <Typography
                                gutterBottom
                                className={classes.variantViewHedingeProg}
                              >
                                Products History
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid>
                            <TableContainer>
                              <Table className={classes.table}>
                                <TableHead className={classes.tableHeaderRow}>
                                  <TableRow>
                                    <TableCell
                                      className={classes.tablheaderNoWidth}
                                      sx={{ width: "5%" }}
                                    >
                                      <strong>#</strong>
                                    </TableCell>
                                    <TableCell
                                      className={classes.tablheader}
                                      sx={{ width: "60%" }}
                                    >
                                      <strong>Name</strong>
                                    </TableCell>

                                    <TableCell
                                      className={classes.tablheader}
                                      sx={{ textAlign: "right" }}
                                    >
                                      <strong>Actions</strong>
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {mainItemIsError ||
                                  mainItemlist.length === 0 ? (
                                    <TableRow>
                                      <TableCell colSpan={20} align="center">
                                        {mainItemIsError
                                          ? "Error fetching data"
                                          : "No data available"}
                                      </TableCell>
                                    </TableRow>
                                  ) : (
                                    mainItemlist
                                      .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                      )
                                      .map((row: IMainItem, index) => (
                                        <TableRow
                                          key={row.id}
                                          className={classes.tableRowHover}
                                        >
                                          <TableCell
                                            scope="row"
                                            className={classes.tablCell}
                                            // sx={{ textAlign: "center" }}
                                          >
                                            {index + 1}
                                          </TableCell>

                                          <TableCell
                                            scope="row"
                                            className={classes.tablCell}
                                          >
                                            <Link
                                              to={`/main/item/view/${row.id}`}
                                              className={
                                                classes.iconLinkPropNormal
                                              }
                                            >
                                              <Grid
                                                container
                                                spacing={1}
                                                alignItems="center"
                                                sx={{ cursor: "pointer" }}
                                                onClick={() =>
                                                  navigate(
                                                    `/main/item/view/${row.id}`
                                                  )
                                                }
                                              >
                                                <Grid item xs="auto">
                                                  <Box
                                                    className={
                                                      classes.SelectImageTableBoxwithBorder
                                                    }
                                                  >
                                                    {row.mainItemImg ||
                                                    ReplaceImage ? (
                                                      <img
                                                        src={
                                                          row.mainItemImg ||
                                                          ReplaceImage
                                                        }
                                                        alt="img"
                                                        // alt={row.variantName.toLowerCase()}
                                                        className={
                                                          classes.SelectImageTable
                                                        }
                                                        onError={(e) =>
                                                          (e.currentTarget.src =
                                                            ReplaceImage)
                                                        }
                                                      />
                                                    ) : (
                                                      <IoIosImages
                                                        className={
                                                          classes.SelectImageTable
                                                        }
                                                      />
                                                    )}
                                                  </Box>
                                                </Grid>
                                                <Grid item xs>
                                                  <Typography
                                                    className={
                                                      classes.nameTableList
                                                    }
                                                  >
                                                    {capitalizeFirstLetter(
                                                      row.mainItemName
                                                    )}
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Link>
                                          </TableCell>

                                          <TableCell
                                            className={classes.tablCell}
                                          >
                                            <Grid
                                              container
                                              spacing={1}
                                              sx={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                              }}
                                            >
                                              <Grid item>
                                                <Link
                                                  to={`/main/item/view/${row.id}`}
                                                  className={
                                                    classes.iconLinkPropNormal
                                                  }
                                                >
                                                  <Button
                                                    className={
                                                      classes.viewButtonList
                                                    }
                                                  >
                                                    <VisibilitySharpIcon
                                                      className={
                                                        classes.viewListIcon
                                                      }
                                                    />
                                                  </Button>
                                                </Link>
                                              </Grid>
                                            </Grid>
                                          </TableCell>
                                        </TableRow>
                                      ))
                                  )}
                                </TableBody>
                              </Table>

                              <Grid
                                spacing={5}
                                p={"18px"}
                                py={4}
                                justifyContent={"end"}
                                container
                                textAlign={"center"}
                                alignContent={"center"}
                                alignItems={"center"}
                              >
                                <Grid
                                  sx={{
                                    textAlign: "end",
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end",
                                  }}
                                >
                                  <Pagination
                                    count={mainItemlist.length}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    onPageChange={handleChangePage}
                                  />
                                </Grid>
                              </Grid>
                            </TableContainer>
                          </Grid>
                        </Card>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </div>
        );
      case Section.Store:
        return (
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard} sx={{ p: "24px" }}>
                <Grid container spacing={2}>
                  {/* {(product?.itemServiceCharge ||
                    product?.itemServiceChargePrice) && (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={2}
                      >
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography
                            gutterBottom
                            className={classes.variantViewHedingeProg}
                          >
                            Item Service Charge
                          </Typography>
                          <Stack spacing={1} px={2} py={1}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <MonetizationOnIcon
                                color="success"
                                sx={{ mr: 1 }}
                              />
                              <Typography variant="body2">
                                Type:{" "}
                                {product?.itemServiceCharge === "1"
                                  ? "Pay"
                                  : "None"}
                              </Typography>
                            </Box>
                            {product?.itemServiceCharge &&
                              product?.itemServiceCharge == "1" && (
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <PriceChangeIcon
                                    color="primary"
                                    sx={{ mr: 1 }}
                                  />
                                  <Typography variant="body2">
                                    Price: ${product.itemServiceChargePrice}
                                  </Typography>
                                </Box>
                              )}
                          </Stack>
                        </Grid>
                      </Grid>
                    </Grid>
                  )} */}
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Card className={classes.stepperCard}>
                      <Typography
                        gutterBottom
                        className={classes.variantViewHedingeProg}
                      >
                        Store Summary
                      </Typography>

                      {product?.selectStore &&
                      product.selectStore.length > 0 ? (
                        <Grid container spacing={3}>
                          {product.selectStore.map((id) => (
                            <Grid item lg={4} md={6} sm={12} xs={12}>
                              <Paper
                                elevation={1}
                                sx={{
                                  p: 2.5,
                                  borderRadius: "4px",
                                  height: "100%",
                                  background:
                                    "linear-gradient(to bottom, #f9f9f9, #fff)",
                                  border: "1px solid #e0e0e0",
                                }}
                              >
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={2}
                                >
                                  <Avatar
                                    color="primary"
                                    sx={{
                                      background:
                                        "linear-gradient(to bottom, #f9f9f9, #fff)",
                                    }}
                                  >
                                    <StoreIcon color="primary" />
                                  </Avatar>
                                  <Typography
                                    variant="subtitle1"
                                    fontWeight="bold"
                                  >
                                    {getStoreMap.get(id) || "Unnamed Supplier"}
                                  </Typography>
                                </Stack>
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      ) : (
                        <Typography variant="body2" color="text.secondary">
                          No pricing details available for any store.
                        </Typography>
                      )}
                    </Card>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        );
      default:
        return null;
    }
  };

  if (isError) {
    return (
      <Typography color="error">
        Error fetching product details data. Please try again later.
      </Typography>
    );
  }

  const coursings: IVariantView[] = Array.isArray(
    productHistoryRecordData?.data
  )
    ? (productHistoryRecordData?.data as IVariantView[])
    : [];

  return (
    <Grid container spacing={3}>
      <Grid item lg={3} md={4} sm={12} xs={12}>
        <Card className={classes.stepperCard} sx={{ height: "100%" }}>
          <Grid container spacing={2} p={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                container
                justifyContent={"center"}
                spacing={2}
                sx={{ padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  display={isMobileRes ? "flex" : undefined}
                  alignContent={"center"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Box className={classes.productBox}>
                    {product?.categoryImg || ReplaceImage ? (
                      <img
                        src={product?.categoryImg || ReplaceImage}
                        alt="img"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "cover",
                          borderRadius: "6px",
                        }}
                        onError={(e) => (e.currentTarget.src = ReplaceImage)}
                      />
                    ) : (
                      <IoIosImages style={{ fontSize: 60 }} />
                    )}
                  </Box>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography variant="h4" textAlign={"center"}>
                    {toProperCase(product?.categoryName)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={2}
                sx={{ px: 2, pb: 3 }}
                className={classes.titleGrid}
              >
                <Grid item xs={12}>
                  <Stack spacing={1}>
                    <DetailRow
                      label="Name"
                      value={toProperCase(product?.categoryName)}
                    />

                    {product?.parent_ids && product?.parent_ids.length > 0 && (
                      <DetailRow
                        label="Perent Category"
                        value={product.parent_ids
                          ?.map((id) => categoryMap.get(id) || " ")
                          .join(" → ")}
                      />
                    )}

                    {product?.servingSize &&
                      product?.servingSize.length > 0 && (
                        <DetailRow
                          label="Serving Size Levels"
                          value={product.servingSize
                            .map((size: number) => getSizeLabel(size))
                            .join(" , ")}
                        />
                      )}

                    {product?.taxeId && (
                      <DetailRow
                        label="Tax"
                        value={taxMap.get(product.taxeId) || ""}
                      />
                    )}

                    {product?.orderNumber && (
                      <DetailRow
                        label="Order Number"
                        value={product.orderNumber}
                      />
                    )}

                    {product?.roleId && product?.roleId?.length > 0 && (
                      <DetailRow
                        label="Roles"
                        value={product.roleId
                          .map((size: number) => getRooleTypeLabel(size))
                          .join(" , ")}
                      />
                    )}
                    {/* 
                    {product?.itemServiceChargeId && (
                      <DetailRow
                        label="Item Service Charge"
                        value={getItemServiceSizeLabel(
                          product.itemServiceChargeId
                        )}
                      />
                    )} */}

                    {product?.parent_ids && product?.parent_ids?.length > 0 && (
                      <DetailRow
                        label="Printers"
                        value={product.parent_ids
                          .map((id) => printerMap.get(id) || "")
                          .join(", ")}
                      />
                    )}

                    {product?.orderNumber && (
                      <DetailRow
                        label="Order Number"
                        value={product.orderNumber}
                      />
                    )}

                    {product?.bgColor && (
                      <DetailRow
                        label="Button Color"
                        value={
                          <Chip
                            label=" "
                            sx={{
                              backgroundColor: product.bgColor,
                              width: 24,
                              height: 24,
                            }}
                          />
                        }
                      />
                    )}

                    {product?.created_by && (
                      <DetailRow
                        label="Created by"
                        value={userMap.get(product.created_by)}
                      />
                    )}

                    {product?.created_at && (
                      <DetailRow
                        label="Created at"
                        value={dayjs(product.created_at).format(
                          "MMM D, YYYY h:mm A"
                        )}
                      />
                    )}

                    {product?.updated_by && (
                      <DetailRow
                        label="Updated by"
                        value={userMap.get(product.updated_by)}
                      />
                    )}

                    {product?.updated_by && product?.updated_at && (
                      <DetailRow
                        label="Updated at"
                        value={dayjs(product.updated_at).format(
                          "MMM D, YYYY h:mm A"
                        )}
                      />
                    )}
                  </Stack>
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  {product && (
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-end"
                      sx={{ display: "flex" }}
                    >
                      <Grid item>
                        <Button
                          // variant="contained"
                          className={classes.editButtonList}
                          onClick={() => handleOpenDialog(product)}
                        >
                          <EditSharpIcon className={classes.editListIcon} />
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          // variant="contained"
                          className={classes.deleteButtonList}
                          onClick={() => handleOpenDeletePopup(product)}
                        >
                          <DeleteOutlineSharpIcon
                            className={classes.deleteListIcon}
                          />
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item lg={9} md={8} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <CompactStatusCard
                  label="Active"
                  status={!!product?.isActive}
                />
              </Grid>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <CompactStatusCard
                  label="Can Sell"
                  status={!!product?.isOnSale}
                />
              </Grid>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <CompactStatusCard
                  label="Display"
                  status={!!product?.isPosDisplay}
                />
              </Grid>
              <Grid item lg={3} md={6} sm={6} xs={12}>
                <CompactStatusCard
                  label="Looping"
                  status={!!product?.categoryIsLooping}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={2.5} md={4} sm={6} xs={12}>
                <Card
                  className={
                    activeSection === Section.Store
                      ? classes.selectedcardVariant
                      : classes.unselectedcardVariant
                  }
                  onClick={() => handleContainerChange(Section.Store)}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar
                      className={
                        activeSection === Section.Store
                          ? classes.selectedcardVariantAvart
                          : classes.unselectedcardVariantAvatar
                      }
                    >
                      <StoreIcon />
                    </Avatar>
                    <Typography fontWeight={600}>{`Store (${
                      product?.selectStore ? product.selectStore.length : 0
                    })`}</Typography>
                  </Stack>
                </Card>
              </Grid>
              <Grid item lg={2.5} md={4} sm={6} xs={12}>
                <Card
                  className={
                    activeSection === Section.Product
                      ? classes.selectedcardVariant
                      : classes.unselectedcardVariant
                  }
                  onClick={() => handleContainerChange(Section.Product)}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar
                      className={
                        activeSection === Section.Product
                          ? classes.selectedcardVariantAvart
                          : classes.unselectedcardVariantAvatar
                      }
                    >
                      <ShoppingBasketIcon />
                    </Avatar>
                    <Typography fontWeight={600}>
                      {`Products  (${mainItemlist.length})`}{" "}
                    </Typography>
                  </Stack>
                </Card>
              </Grid>
              <Grid item lg={2.5} md={4} sm={6} xs={12}>
                <Card
                  className={
                    activeSection === Section.Items
                      ? classes.selectedcardVariant
                      : classes.unselectedcardVariant
                  }
                  onClick={() => handleContainerChange(Section.Items)}
                >
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar
                      className={
                        activeSection === Section.Items
                          ? classes.selectedcardVariantAvart
                          : classes.unselectedcardVariantAvatar
                      }
                    >
                      <ShoppingCartIcon />
                    </Avatar>
                    <Typography fontWeight={600}>
                      {`Items  (${storeItemsList.length})`}{" "}
                    </Typography>
                  </Stack>
                </Card>
              </Grid>
            </Grid>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            {renderContent()}
          </Grid>
        </Grid>
      </Grid>

      {selectedProduct && (
        <NewPopUpProduct
          openModel={openDialogProduct}
          handleCloseDialog={handleCloseDialog}
          data={selectedProduct}
        />
      )}

      {productToDelete && (
        <DeletePopup
          open={openDeleteProduct}
          handleCloseDelete={handleCloseDeletePopup}
          onConfirm={async () => {
            await handleDelete(productToDelete.id.toString());
          }}
          title="Delete Category"
          content={`Are you sure you want to delete "${productToDelete.categoryName}"?`}
        />
      )}
    </Grid>
  );
};

export default Index;
